import React from 'react';
import HeroProjectS2 from './heroProjectS2';

const hero8 = () => {
    return (
        <section className="wpo-hero-static-s6">
            <div className="wrapper">
                <h2>Renovating Your Place</h2>
                <p>Blaze is a trailblazing architecture agency renowned for its innovative approach to design.</p>
            </div>
            <HeroProjectS2/>
        </section>
    );
};

export default hero8;